// extracted by mini-css-extract-plugin
export var marginNegative = "_6k-5 _6k-3 _6k-1";
export var marginPositive = "_6k-4 _6k-3 _6k-1";
export var modalContent = "_6k-6";
export var samplesTable = "_6k-8";
export var samplesTableContainer = "_6k-7";
export var statBox = "_6k-a";
export var tableCell = "_6k-1";
export var tableCellCenter = "_6k-2 _6k-1";
export var tableCellRight = "_6k-3 _6k-1";
export var tableHeader = "_6k-0";
export var trackingNumber = "_6k-9";